<template>
  <div v-loading="loading">
    <FormBox
      v-if="!$route.meta.search"
      :title="$t('message.DataRegistration.International.baseInfo')"
    >
      <template slot="right">
        <el-button
          type="primary"
          plain
          @click="$router.push('/internationalPaymentRecord')"
          >{{
            $t("message.DataRegistration.International.checkRecord")
          }}</el-button
        >
      </template>
      <div class="itnal_info_box">
        <el-row :gutter="86">
          <!-- 澳門駕駛執照編號 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("message.macau_driver_no") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.macauDrivingLicenseNo }}
            </div>
          </el-col>
          <!-- 澳門駕駛執照類別 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{
                $t("message.DataRegistration.International.macau_driver_type")
              }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.macauDrivingLicenseTypeCn }}
            </div>
            <div class="itnal_info_data">
              {{ application.cert.macauDrivingLicenseTypeEn }}
            </div>
          </el-col>
          <!-- 澳門駕駛執照有效期至 -->
          <el-col :xs="24" :sm="24">
            <div class="itnal_info_label">
              {{
                $t(
                  "message.DataRegistration.International.macau_driver_no_date"
                )
              }}:
            </div>
            <div class="itnal_info_data">
              {{
                application.cert.macauDrivingLicenseExpiredDate
                  | formatDT("dd/MM/yyyy")
              }}
            </div>
          </el-col>
          <!-- 姓 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.surname") }}:
            </div>
            <div class="itnal_info_data">{{ application.cert.lastNameCn }}</div>
            <div class="itnal_info_data">{{ application.cert.lastNameEn }}</div>
          </el-col>
          <!-- 名 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.name") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.firstNameCn }}
            </div>
            <div class="itnal_info_data">
              {{ application.cert.firstNameEn }}
            </div>
          </el-col>
          <!-- 出生日期 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.birthday") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.birthdate | formatDT("dd/MM/yyyy") }}
            </div>
          </el-col>
          <!-- 出生地 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.birthPlace") }}:
            </div>
            <div class="itnal_info_data">
              {{ application.cert.birthplaceCn }}
            </div>
            <div class="itnal_info_data">
              {{ application.cert.birthplaceEn }}
            </div>
          </el-col>
          <!-- 身份證明文件類別 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">{{ $t("message.idType") }}:</div>
            <div class="itnal_info_data">{{ application.identityTypeCn }}</div>
            <div class="itnal_info_data">{{ application.identityTypeEn }}</div>
          </el-col>
          <!-- 身份證明文件編號 -->
          <el-col :xs="24" :sm="12">
            <div class="itnal_info_label">{{ $t("message.idNo") }}:</div>
            <div class="itnal_info_data">{{ application.identityNo }}</div>
          </el-col>
        </el-row>
        <div class="infoTips">
          {{ $t("message.DataRegistration.International.infoTips") }}
        </div>
      </div>
      <!-- 表單 -->
      <el-form
        v-if="
          application &&
          application.spCode == '00' &&
          !$route.query.authentication
        "
        ref="ruleForm"
        :model="application"
        class="form_type1_box"
        hide-required-asterisk
        :rules="ruleForm"
      >
        <el-row :gutter="86">
          <!-- 本次申請國際駕照有效期至 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="
                $t(
                  'message.DataRegistration.International.internationalLicenseExpiredDate'
                )
              "
            >
              <el-input
                v-model="application.internationalLicenseExpiredDate"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 國際駕照領證地點 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="
                $t(
                  'message.DataRegistration.International.internationalAddress'
                )
              "
              prop="addresses"
            >
              <el-select
                v-model="application.addresses"
                filterable
                value-key="code"
              >
                <el-option
                  v-for="item in statusType"
                  :key="item.code"
                  :label="item[`name${$t('message.lans')}`]"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <!-- 聯絡電話 -->
          <el-col :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.International.mobile')"
            >
              <el-input
                v-model="application.macauMobile"
                placeholder=""
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- 語言偏好 -->
          <el-col v-if="application" :xs="24" :sm="12">
            <el-form-item
              :label="$t('message.DataRegistration.International.language')"
              prop="language"
            >
              <el-select v-model="application.language" filterable disabled>
                <el-option
                  v-for="item in language"
                  :key="item.code"
                  :label="$t(item.label)"
                  :value="item.code"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col
            v-if="showDiffTips"
            :xs="24"
            :sm="24"
          >
            <div class="device_deff_tips">
              {{
                $t("message.DataRegistration.International.device_deff_tips", [
                  String(application.cert.macauMoblie).slice(0, 4 * -1) +
                    "****",
                  application.cert[`lanauage${$t("message.lans")}`],
                ])
              }}
            </div>
            <!-- <div class="m-divider-box">
              <div class="m-divider__text">
                {{ $t("message.DataRegistration.International.device_data") }}
              </div>
              <div class="m-divider__content">
                {{
                  String(application.cert.macauMoblie).slice(0, 4 * -1) +
                  "*".repeat(4)
                }}
                /
                {{ application.cert[`lanauage${$t("message.lans")}`] }}
              </div>
            </div> -->
          </el-col>
          <!-- 注意事項 -->
          <el-col :xs="24" :sm="24">
            <el-form-item
              :label="$t('message.DataRegistration.International.notice')"
              prop="sendSms"
            >
              <div class="itnal_info_question">
                {{
                  $t("message.DataRegistration.International.question1", [
                    language.filter((ele) => ele.code === $t("message.lang"))[0]
                      .label,
                  ])
                }}
              </div>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24">
            <div class="payment_notice">
              <div class="pn_title">
                {{ $t("message.DataRegistration.Taxi.notice") }}
                <span
                  style="color: #ee7a34; font-size: 20px; font-weight: bold"
                >
                  {{
                    $t("message.DataRegistration.International.payment_notice")
                  }}
                </span>
              </div>
              <ul class="pn_list">
                <li>
                  <span class="pn_email_text">{{
                    $t("message.DataRegistration.Taxi.email")
                  }}</span>
                  <!-- 電子郵件 -->
                  <el-form-item label="" prop="email">
                    <el-input
                      v-model="application.email"
                      :placeholder="
                        $t('message.DataRegistration.Taxi.email_plh')
                      "
                    ></el-input>
                  </el-form-item>
                  <!-- 電子郵件確認 -->
                  <el-form-item label="" prop="confirmEmail">
                    <el-input
                      v-model="application.confirmEmail"
                      :placeholder="
                        $t('message.DataRegistration.Taxi.email_again_plh')
                      "
                    ></el-input>
                  </el-form-item>
                </li>
              </ul>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </FormBox>
    <!-- 查詢補交 -->
    <FormBox
      v-else
      :title="$t('message.DataRegistration.International.baseInfo')"
      class="hide_formGroup_title"
    >
      <div class="itnal_info_box">
        <el-row :gutter="86">
          <!-- 個案查詢編號 -->
          <el-col :xs="24" :sm="12" :md="8">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.spNo") }}:
            </div>
            <div class="itnal_info_data">
              {{ application && application.spNo }}
            </div>
          </el-col>
          <!-- 澳門駕駛執照編號 -->
          <el-col :xs="24" :sm="12" :md="8">
            <div class="itnal_info_label">
              {{ $t("message.macau_driver_no") }}:
            </div>
            <div class="itnal_info_data">
              {{ application && application.macauDrivingLicenseNo }}
            </div>
          </el-col>
          <!-- 申請日期 -->
          <el-col :xs="24" :sm="12" :md="8">
            <div class="itnal_info_label">
              {{ $t("message.DataRegistration.International.applyDate") }}:
            </div>
            <div class="itnal_info_data">
              {{
                application && application.appliedTime | formatDT("dd/MM/yyyy")
              }}
            </div>
          </el-col>
        </el-row>
      </div>
    </FormBox>
  </div>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import ServiceTypeConfigAPI from "../../../../api/ServiceTypeConfigAPI";
import FormBox from "./FormBox";
export default {
  props: ["form", "application", "appLanguage", "showDiffTips"],
  components: { FormBox },
  data() {
    let emailCheck = (rule, value, callback) => {
      if (
        this.application.confirmEmail &&
        value !== this.application.confirmEmail
      ) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    let confirmEmailCheck = (rule, value, callback) => {
      if (this.application.email && !value) {
        callback(new Error(i18n.t("message.formRuleMessage.taxi_email")));
      } else if (this.application.email && value !== this.application.email) {
        callback(
          new Error(i18n.t("message.formRuleMessage.taxi_email_confirm"))
        );
      } else {
        callback();
      }
    };
    return {
      loading: false,
      myForm: {
        sendSms: true,
      },
      ruleForm: {
        internationalAddress: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
        ],
        language: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
        ],
        addresses: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "change",
          },
        ],
        email: [
          { validator: emailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
        confirmEmail: [
          { validator: confirmEmailCheck, trigger: "blur" },
          {
            type: "email",
            message: i18n.t("message.formRuleMessage.email"),
            trigger: ["blur"],
          },
        ],
      },
      statusType: [],
      language: [
        { code: "ZH_HANT", label: "繁體中文" },
        { code: "ZH_HANS", label: "简体中文" },
        { code: "EN", label: "English" },
        { code: "PT", label: "Português" },
      ],
      idType: [
        { code: "BM", label: "message.idType_macau" },
        {
          code: "OTHER",
          label: "message.idType_other",
        },
      ],
      verifyForm: {},
    };
  },
  methods: {
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 獲取領證地點
    getZones() {
      this.loading = true;
      ServiceTypeConfigAPI.getZones("DRV_LIC_INTER")
        .then((res) => {
          this.loading = false;
          this.statusType = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
  },
  created() {
    this.getZones();
    this.verifyForm = JSON.parse(localStorage.getItem("verifyForm")) || {};
  },
};
</script>

<style lang="scss" scoped>
.itnal_info_box {
  background: #fffcf0;
  border: 1px solid #f7b463;
  border-radius: 10px;
  margin: 24px auto;
  overflow: hidden;
  .el-row {
    align-items: flex-start;
    padding: 24px 4%;
  }
  .el-col {
    margin-bottom: 20px;
  }
  .infoTips {
    background: #e54b5d;
    color: #fff;
    font-size: 18px;
    padding: 10px;
    text-align: center;
  }
}
.itnal_info_label {
  color: #7f7f7f;
  font-size: 18px;
}
.itnal_info_data {
  color: #333;
  font-size: 18px;
}
.itnal_info_question {
  background: #f2f2f2;
  color: #333;
  font-size: 16px;
  padding: 5px 10px;
  border-radius: 10px;
  clear: both;
}
.hide_formGroup_title {
  /deep/.formGroup_title {
    display: none;
  }
}
.update_tips {
  display: inline-block;
  background: #e54b5d;
  color: #fff;
  font-size: 18px;
  padding: 10px;
  border-radius: 10px;
}

.payment_notice {
  max-width: 700px;
  margin: auto;
  padding: 30px;
  background: #fef9f3;
  border: 1px solid #facd91;
  border-radius: 5px;
}
.pn_title {
  color: #f59a23;
  font-size: 26px;
  margin-bottom: 20px;
}
.pn_list {
  /deep/.el-form {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  /deep/.el-form-item {
    margin-right: 20px;
  }
  /deep/.el-form-item.is-error .el-input__inner {
    box-shadow: 0 0 black;
  }
}
.pn_list li {
  margin-bottom: 12px;
  font-size: 18px;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.pn_list li span {
  display: inline-block;
  min-width: 180px;
}
.pn_list li .el-input {
  flex: 1;
  margin-right: 20px;
}
/deep/.pn_list li .el-input input {
  border: 0;
  border-radius: 0;
  border-bottom: 1px solid #333;
  background-color: transparent;
  text-align: center;
}
/deep/.device_deff_tips {
  color: #e54b5d;
  padding: 20px 0;
  font-size: 18px;
}

@media screen and (max-width: 767px) {
  .payment_notice {
    margin-left: 15px;
    margin-right: 15px;
  }
  .pn_email_text {
    margin-bottom: 20px;
  }
  .pn_list li {
    flex-direction: column;
  }
}
</style>